import { combineReducers } from "@reduxjs/toolkit";
import { companySettingsApi } from "./features/CompanySetting";
import { couponApi } from "./features/Revenue/CouponApi";
import { feeCalculationApi } from "./features/Revenue/FeeCalculationApi";
import { feePlanApi } from "./features/Revenue/FeePlan";
import { proformaApi } from "./features/Revenue/ProformaApi";
import { settingsApi } from "./features/SettingsApi";
import {
  appReducer,
  equityBasketReducer,
  exportReducer,
  portfolioReducer,
  tableReducer,
  userReducer,
} from "./slices";

const apis = [
  companySettingsApi,
  feePlanApi,
  feeCalculationApi,
  couponApi,
  proformaApi,
  settingsApi,
];

// ---- Root Reducer ----
export const rootReducer = combineReducers({
  portfolio: portfolioReducer,
  app: appReducer,
  table: tableReducer,
  export: exportReducer,
  user: userReducer,
  equityBasket: equityBasketReducer,
  ...Object.fromEntries(apis.map((api) => [api.reducerPath, api.reducer])),
});

// ---- Middlewares ----
export const apiMiddlewares = apis.map((api) => api.middleware);
